import React, { Fragment } from 'react';
import { DialogOverlay } from '@reach/dialog';
import { keyframes, styled } from 'styled-components';
import { useDialogState } from './DialogContext';
import { zIndex } from '../../../../play-core/styles/z-index';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogContainer = () => {
  const {
    dialog
  } = useDialogState();
  return /*#__PURE__*/_jsx(Fragment, {
    children: !!dialog && /*#__PURE__*/_jsx(StyledDialogOverlay, {
      children: /*#__PURE__*/_jsx(DialogAnimation, {
        children: dialog
      })
    })
  });
};
const StyledDialogOverlay = styled(DialogOverlay).withConfig({
  displayName: "DialogContainer__StyledDialogOverlay",
  componentId: "sc-1y2axrh-0"
})(["z-index:", ";display:flex;justify-content:center;align-items:center;&[data-reach-dialog-overlay]{background-color:rgba(0,0,0,0.5);}"], zIndex.dialog);
const scale = keyframes`
0% {
  opacity: 0;
  transform: scale(0.9);
}
100% {
  opacity: 1;
  transform: scale(1);
}
`;
const DialogAnimation = styled.div.withConfig({
  displayName: "DialogContainer__DialogAnimation",
  componentId: "sc-1y2axrh-1"
})(["animation:", " 100ms ease-in;"], scale);